import React, { Component } from 'react';
import I18n from '~/utils/translations';
import { readCookie, writeCookie } from './utils/cookies';

export default class CookieOptIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayBanner: props.displayBanner,
    };
  }

  render() {
    if (this.state.displayBanner) {
      return this.renderCookiePolicyBanner();
    }
    return null;
  }

  renderCookiePolicyBanner() {
    return (
      <div className="cookie-opt-in">
        <p className="cookie-opt-in__info-text">
          {I18n.t('allow_cookies.body.text')}{' '}
          <a className="cookie-opt-in__link" href={I18n.t('allow_cookies.more.link')} target="_blank">
            {' '}
            {I18n.t('allow_cookies.more.text')}
          </a>
        </p>
        <button
          className="cookie-opt-in__confirm-button cookie-opt-in__confirm-button--tertiary"
          onClick={this.setOptInCookie}
        >
          {I18n.t('allow_cookies.button')}
        </button>
      </div>
    );
  }

  setOptInCookie = () => {
    writeCookie('cookie_opt_in', true, 30);
    this.setState({ displayBanner: false });
  };
}
